import React, {Component} from "react";
import "./MessaggioRender.css";
import TrashIcon from "../../../media/assets/TrashIcon.mjs";
import AppEditIcon from "../../../media/assets/AppEditIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import BLib from "../BLib.mjs";
import Glob from "../../../libs/Glob.mjs";
import AppCercoIcon from "../../../media/assets/AppCercoIcon.mjs";
import AppOffroIcon from "../../../media/assets/AppOffroIcon.mjs";
import AppLikedIcon from "../../../media/assets/AppLikedIcon.mjs";
import AppLikeIcon from "../../../media/assets/AppLikeIcon.mjs";
import {UncontrolledTooltip} from "reactstrap";
import TextLabel from "../../../controls/TextLabel.mjs";
import AppDislikeIcon from "../../../media/assets/AppDislikeIcon.mjs";
import EyeOffIcon from "../../../media/assets/EyeOffIcon.mjs";
import MailIcon from "../../../media/assets/MailIcon.mjs";
import SettingsIcon from "../../../media/assets/SettingsIcon.mjs";

const prefix = "MessaggioRender";

const MessaggioRender = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			/** This message belongs to me */
			mine: props.user?.id && (props.user?.id === props.data?.userid),
			/** I've mod privileges */
			mod: !! props.user?.moderator,
			hidden: BLib.hidden( props.data?.id ),
		}
		this.actionDelete = this.actionDelete.bind(this);
		this.actionEdit = this.actionEdit.bind(this);
		this.actionLike = this.actionLike.bind(this);
		this.actionDislike = this.actionDislike.bind(this);
		this.actionHide = this.actionHide.bind(this);
		this.actionReply = this.actionReply.bind(this);
		this.actionModerate = this.actionModerate.bind(this);
		this.additionalClassName = this.additionalClassName.bind(this);
		this.buildClassName = this.buildClassName.bind(this);
		this.renderPreBox = this.renderPreBox.bind(this);
		this.renderAuthorSideBar = this.renderAuthorSideBar.bind(this);
		this.renderAuthorBar = this.renderAuthorBar.bind(this);
		this.renderSubject = this.renderSubject.bind(this);
		this.renderBody = this.renderBody.bind(this);
		this.renderActions = this.renderActions.bind(this);
		this.renderActionsSub1 = this.renderActionsSub1.bind(this);
		this.renderActionsSub2 = this.renderActionsSub2.bind(this);
		this.renderActionsSub3 = this.renderActionsSub3.bind(this);
		this.renderPostBox = this.renderPostBox.bind(this);
		this.uid = Glob.generateUid(prefix);
	}
	actionHide() {
		BLib.hide( this.props.data?.id );
		this.setState({ hidden: BLib.hidden( this.props.data?.id ) });
	}
	actionEdit() {
		Glob.trigger('MessaggeEdit', this.props.data );
	}
	actionReply() {
		Glob.trigger('ReplyByMail', this.props.data );
	}
	actionLike() {
		this.setState({ saving: true }, ()=>{
			appLib.api('bacheca/toggle-like-message', {message: this.props.data.id}).then(() => {
				BLib.restartPoll();
			}).catch((err) => {
				console.log(err);
			}).finally( ()=>{
				this.setState({ saving: false });
			});
		});
	}
	actionDislike() {
		Glob.trigger('ReportInappropriate', this.props.data );
	}
	actionDelete() {
		if ( ! window.confirm(`Sei sicuro di voler eliminare il messaggio “${this.props.data.subject.replace(/`/g,"'")}”?

Questa azione non può essere annullata.`)) return;
		this.setState({ saving: true }, ()=>{
			appLib.api('bacheca/toggle-delete-message', {message: this.props.data.id}).then(() => {
				BLib.restartPoll();
			}).catch((err) => {
				console.log(err);
			}).finally( ()=>{
				this.setState({ saving: false });
			});
		});
	}
	actionModerate() {
		Glob.trigger('ModerateAction', this.props.data);
	}
	additionalClassName() {
		return null;
	}
	buildClassName(m = this.props.data) {
		const out = [prefix];
		if ( this.state.saving ) out.push("busy");
		if ( this.state.mine ) out.push("mine");
		if ( this.state.hidden ) out.push("hidden");
		out.push(this.additionalClassName(m));
		return out.filter( x => !! x ).join(" ");
	}
	renderPreBox() {
		return null;
	}
	renderAuthorSideBar( m = this.props.data ) {
		const out=[];
		if ( m.meta.likes ) out.push(
			<div className={"side likes"} id={`likers-${this.uid}`}  key={`likers-${this.uid}`}>
				<AppLikedIcon />
				{ m.meta.likes > 1 && <span>{ m.meta.likes }</span> }
				<UncontrolledTooltip target={`likers-${this.uid}`} placement={"bottom-end"}>
					{ m.meta.likename.sort().map( (x,i) => <div key={i}>{x}</div>) }
				</UncontrolledTooltip>
			</div>
		);
		if ( m.meta.segnalazioni ) out.push(
			<div className={"side reports"} id={`reports-${this.uid}`}  key={`reports-${this.uid}`}>
				<AppDislikeIcon />
				{ m.meta.segnalazioni > 1 && <span>{ m.meta.segnalazioni }</span> }
				<UncontrolledTooltip target={`reports-${this.uid}`} placement={"bottom-end"}>
					{ m.meta.segnalazioniname.sort().map( (x,i) => <div key={i}>{x}</div>) }
				</UncontrolledTooltip>
			</div>
		)
		return out;
	}
	renderAuthorBar(m = this.props.data) {
		return(
			<div className={"author"}>
				{ this.props.extra?.axle && ( m.axle === 'cerco' ? <AppCercoIcon /> : <AppOffroIcon /> )}
				{ ( !! m.meta.name ) && <strong> { m.meta.name } </strong> }
				<span>
					{ (new Date(m.created)).toLocaleDateString( this.props.ll ) }
				</span>
				{ this.renderAuthorSideBar( m) }
			</div>
		);
	}
	renderSubject(m = this.props.data) {
		return(
			<div
				className="subject"
				onClick={ ()=>{ if ( this.state.hidden ) this.actionHide() }}
			>
				{ m.subject }
			</div>
		);
	}
	renderBody( m = this.props.data) {
		if ( this.state.hidden ) return null;
		if (m.private && ! this.props.user ) return (
			<div className="body private">
				{ this.props.lang === 'it' ? 'Visibile solo dopo il login' : 'Only for authenticated users' }.
			</div>
		);
		return <div className="body">{ m.body }</div>;
	}
	renderActionsSub1( m = this.props.data ){
		if ( this.state.mine ) return (
			<span className={"delete"} onClick={ this.actionDelete } id={`delete-${this.uid}`} key={`delete-${this.uid}`}>
				<TrashIcon />
				<UncontrolledTooltip target={`delete-${this.uid}`} placement={"bottom-start"}>
					<TextLabel value={"Delete"} />
				</UncontrolledTooltip>
			</span>
		);
		if ( this.state.mod ) return (
			<span className={"moderate"} onClick={ this.actionModerate } id={`mod-${this.uid}`} key={`mod-${this.uid}`}>
				<SettingsIcon />
				<UncontrolledTooltip target={`mod-${this.uid}`} placement={"bottom-start"}>
					<TextLabel value={"Moderation"} />
				</UncontrolledTooltip>
			</span>
		);
		if ( m.meta.admin ) return null;
		return (
			<span className={"dislike"} onClick={ this.actionDislike } id={`dislike-${this.uid}`} key={`dislike-${this.uid}`}>
				<AppDislikeIcon />
				<UncontrolledTooltip target={`dislike-${this.uid}`} placement={"bottom-start"}>
					<TextLabel value={"ReportMessage"} />
				</UncontrolledTooltip>
			</span>
		);
	}
	renderActionsSub2( m = this.props.data ){
		if ( this.state.mine || m.nomail) return null;
		return (
			<span className={"reply"} onClick={ this.actionReply } id={`reply-${this.uid}`} key={`reply-${this.uid}`}>
				<MailIcon />
				<UncontrolledTooltip target={`reply-${this.uid}`} placement={"bottom"}>
					<TextLabel value={"Reply"} />
				</UncontrolledTooltip>
			</span>
		);
	}
	renderActionsSub3( m = this.props.data ){
		const out = [];
		out.push(
			<span className={"hide"} onClick={ this.actionHide } id={`hide-${this.uid}`} key={`hide-${this.uid}`}>
				<EyeOffIcon />
				<UncontrolledTooltip target={`hide-${this.uid}`} placement={"bottom"}>
					<TextLabel value={"Hide"} />
				</UncontrolledTooltip>
			</span>
		);
		if ( this.state.mine) {
			out.push(
				<span className={"edit"} onClick={ this.actionEdit } id={`edit-${this.uid}`} key={`edit-${this.uid}`}>
					<AppEditIcon />
					<UncontrolledTooltip target={`edit-${this.uid}`} placement={"bottom-end"}>
						<TextLabel value={"Edit"} />
					</UncontrolledTooltip>
				</span>
			);
		} else if (m.meta.likeid) {
			const liked = m.meta.likeid.includes(this.props.user.id);
			out.push(
				<span className={ liked ? "like liked" : "like"} onClick={ this.actionLike }  key={`likeb-${this.uid}`}>
					{ liked ? <AppLikedIcon /> : <AppLikeIcon /> }
				</span>
			)
		}
		return out;
	}
	renderActions( m = this.props.data) {
		if ( ! this.props.user?.id || this.state.hidden ) return null;
		return(
			<div className={"actions"}>
				<div>
					{ this.renderActionsSub1(m) }
				</div>
				<div>
					{ this.renderActionsSub2(m)}
				</div>
				<div>
					{ this.renderActionsSub3(m) }
				</div>
			</div>
		);
	}
	renderPostBox() {
		return null;
	}
	render() {
		if ( ! this.props.data ) return null;
		/** @type {BachecaMessage} */
		const m = this.props.data;
		return (
			<>
				{ this.renderPreBox(m) }
				<div className={ this.buildClassName(m) } id={ this.uid }>
					{ this.renderAuthorBar(m) }
					<div className={"message"}>
						{ this.renderSubject(m) }
						{ this.renderBody(m) }
					</div>
					{ this.renderActions( m) }
				</div>
				{ this.renderPostBox() }
			</>
		)
	}
}

export default MessaggioRender;
